import React from "react";
import { getTagsByCategory } from "../../constants/footballTaxonomy";

// Multiselect de tags/atributos de fútbol agrupados por categoría (Scout QA #24).
// `value` es un array de codes; `onChange` recibe el nuevo array.
const TagSelector = ({ value = [], onChange, max = 12 }) => {
  const groups = getTagsByCategory();
  const selected = new Set(value);

  const toggle = (code) => {
    const next = new Set(selected);
    if (next.has(code)) {
      next.delete(code);
    } else {
      if (next.size >= max) return; // límite suave
      next.add(code);
    }
    onChange?.([...next]);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-gray-700">
          Atributos destacados
        </p>
        <span className="text-xs text-gray-400">
          {selected.size}/{max}
        </span>
      </div>
      {groups.map((group) => (
        <div key={group.code}>
          <p className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-gray-400">
            {group.label}
          </p>
          <div className="flex flex-wrap gap-2">
            {group.tags.map((tag) => {
              const isOn = selected.has(tag.code);
              return (
                <button
                  key={tag.code}
                  type="button"
                  onClick={() => toggle(tag.code)}
                  aria-pressed={isOn}
                  className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
                    isOn
                      ? "border-blue-900 bg-blue-900 text-white"
                      : "border-gray-300 bg-white text-gray-600 hover:border-blue-400"
                  }`}
                >
                  {tag.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TagSelector;
